module.exports = __webpack_public_path__ + "img/c04_unittechcataphractchampion_Normal_ua.ef2298c2.webp";